module.exports = __webpack_public_path__ + "img/result.c27f3f11.png";